"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var styled_1 = require("../../styled");
var utils_1 = require("../../utils");
var index_1 = require("../TruncatableText/index");
var EnvirioDropdown = function (_a) {
    var _b = _a.addUndefinedOption, addUndefinedOption = _b === void 0 ? true : _b, _c = _a.asSelectButton, asSelectButton = _c === void 0 ? false : _c, _d = _a.autoResizeHeight, autoResizeHeight = _d === void 0 ? false : _d, className = _a.className, id = _a.id, isInline = _a.isInline, label = _a.label, _e = _a.onItemClick, onItemClick = _e === void 0 ? function () { } : _e, optionTextMaxLength = _a.optionTextMaxLength, _f = _a.search, search = _f === void 0 ? true : _f, simple = _a.simple, size = _a.size, sortOptions = _a.sortOptions, theme = _a.theme, baseSemanticDropdownProps = __rest(_a, ["addUndefinedOption", "asSelectButton", "autoResizeHeight", "className", "id", "isInline", "label", "onItemClick", "optionTextMaxLength", "search", "simple", "size", "sortOptions", "theme"]);
    var labelComp = label && isInline ? (React.createElement(InlineInputLabel, null, label)) : label ? (React.createElement(InputLabel, null, label)) : null;
    var options = buildOptions({
        addUndefinedOption: addUndefinedOption,
        optionTextMaxLength: optionTextMaxLength,
        options: baseSemanticDropdownProps.options,
        sortOptions: sortOptions,
    });
    return (React.createElement("div", { className: className }, !asSelectButton ? (React.createElement(React.Fragment, null,
        labelComp,
        React.createElement(semantic_ui_react_1.Dropdown, __assign({}, baseSemanticDropdownProps, { id: id, options: options, search: search })))) : (React.createElement(semantic_ui_react_1.Dropdown, __assign({}, baseSemanticDropdownProps, { button: true, className: "dropdown-activation-button", floating: true, id: id, labeled: true, search: search, text: label }),
        React.createElement(semantic_ui_react_1.Dropdown.Menu, null, Array.isArray(baseSemanticDropdownProps.options)
            ? baseSemanticDropdownProps.options.map(function (option, i) { return (React.createElement(React.Fragment, null,
                React.createElement(semantic_ui_react_1.Dropdown.Item, __assign({ key: i, onClick: function (event) { return onItemClick({ option: option, event: event }); } }, option)))); })
            : [])))));
};
var buildOptions = function (_a) {
    var addUndefinedOption = _a.addUndefinedOption, optionTextMaxLength = _a.optionTextMaxLength, options = _a.options, sortOptions = _a.sortOptions;
    if (options === undefined) {
        return undefined;
    }
    var optionsCopy = __spreadArray([], options);
    if (sortOptions !== undefined) {
        optionsCopy = applySortOptions({ options: optionsCopy, sortOptions: sortOptions });
    }
    if (optionTextMaxLength) {
        optionsCopy = optionsCopy.map(function (option) {
            option.text = index_1.TruncatableText(String(option.text), optionTextMaxLength);
            return option;
        });
    }
    if (addUndefinedOption) {
        optionsCopy = prependUndefinedOption(optionsCopy);
    }
    return optionsCopy;
};
var prependUndefinedOption = function (options) { return __spreadArray([
    {
        key: 'undefined-key',
        text: undefined,
        value: undefined,
    }
], options); };
var applySortOptions = function (_a) {
    var options = _a.options, sortOptions = _a.sortOptions;
    if (typeof sortOptions === 'function') {
        options = options.sort(sortOptions);
    }
    else {
        options = utils_1.sortAlphabeticallyBy(options, sortOptions.by);
        if (sortOptions.descending) {
            options = options.reverse();
        }
    }
    return options;
};
var InlineInputLabel = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: 0.2rem;\n  font-weight: 300;\n  font-size: 1rem;\n  padding-left: 0.9rem;\n"], ["\n  display: block;\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: 0.2rem;\n  font-weight: 300;\n  font-size: 1rem;\n  padding-left: 0.9rem;\n"])), function (props) { return props.theme.colors.black; });
var InputLabel = styled_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: ", ";\n  font-weight: ", ";\n  font-size: 1rem;\n  padding-left: ", ";\n"], ["\n  display: block;\n  color: ", ";\n  opacity: 0.5;\n  margin-bottom: ", ";\n  font-weight: ", ";\n  font-size: 1rem;\n  padding-left: ", ";\n"])), function (props) { return props.theme.colors.black; }, function (props) { return (props.isInline ? '.2rem' : '4px'); }, function (props) { return (props.isInline ? '300' : '800'); }, function (props) { return props.isInline && '.9rem'; });
var getMenuStyles = function (props) {
    if (!props.simple) {
        return "\n      & div[role=\"option\"].item {\n        color: " + props.theme.colors.black + ";\n        font-weight: 300;\n        font-size: 1.33rem;\n      }\n    ";
    }
    return '';
};
var BaseDropdown = styled_1.default(EnvirioDropdown)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  div[role='listbox'].ui.dropdown {\n    font-weight: 300;\n    padding: 0.667rem;\n    height: ", ";\n    border: ", ";\n    border-radius: 0.33rem;\n    background-color: ", ";\n    padding: ", ";\n    white-space: ", ";\n    width: ", ";\n    margin-bottom: ", ";\n    white-space: ", ";\n\n    & div.text {\n      font-size: ", ";\n      margin-right: 0.667rem;\n      white-space: ", ";\n      width: ", ";\n      overflow: ", ";\n      text-overflow: ", ";\n      max-width: ", ";\n      font-weight: ", ";\n      width: ", ";\n    }\n\n    ", ";\n\n    & .menu {\n      max-height: 16.02857143rem;\n      overflow-y: scroll;\n    }\n  }\n\n  div[role='combobox'].ui.search.dropdown {\n    border-radius: 0.33rem;\n    border: 2px solid rgba(0, 36, 45, 0.25);\n    font-weight: 300;\n    padding: 0.667rem;\n    height: ", ";\n    background-color: ", ";\n    padding: ", ";\n    width: ", ";\n    margin-bottom: ", ";\n\n    & input {\n      font-weight: 300;\n      font-size: inherit !important;\n      bottom: 0 !important;\n    }\n\n    ", ";\n\n    & div.text {\n      font-size: ", ";\n      line-height: initial !important;\n      font-weight: ", ";\n      width: ", ";\n      margin-right: 0.667rem;\n    }\n  }\n"], ["\n  div[role='listbox'].ui.dropdown {\n    font-weight: 300;\n    padding: 0.667rem;\n    height: ", ";\n    border: ",
    ";\n    border-radius: 0.33rem;\n    background-color: ",
    ";\n    padding: ",
    ";\n    white-space: ",
    ";\n    width: ", ";\n    margin-bottom: ",
    ";\n    white-space: ",
    ";\n\n    & div.text {\n      font-size: ",
    ";\n      margin-right: 0.667rem;\n      white-space: ",
    ";\n      width: ",
    ";\n      overflow: ",
    ";\n      text-overflow: ",
    ";\n      max-width: ",
    ";\n      font-weight: ",
    ";\n      width: ", ";\n    }\n\n    ", ";\n\n    & .menu {\n      max-height: 16.02857143rem;\n      overflow-y: scroll;\n    }\n  }\n\n  div[role='combobox'].ui.search.dropdown {\n    border-radius: 0.33rem;\n    border: 2px solid rgba(0, 36, 45, 0.25);\n    font-weight: 300;\n    padding: 0.667rem;\n    height: ", ";\n    background-color: ",
    ";\n    padding: ",
    ";\n    width: ", ";\n    margin-bottom: ", ";\n\n    & input {\n      font-weight: 300;\n      font-size: inherit !important;\n      bottom: 0 !important;\n    }\n\n    ", ";\n\n    & div.text {\n      font-size: ",
    ";\n      line-height: initial !important;\n      font-weight: ",
    ";\n      width: ", ";\n      margin-right: 0.667rem;\n    }\n  }\n"])), function (props) { return (props.autoResizeHeight ? 'auto' : 'initial'); }, function (props) {
    return !props.simple ? '2px solid rgba(0, 36, 45, 0.25)' : 'none';
}, function (props) {
    return props.simple ? 'rgba(0, 36, 45, 0.05)' : props.theme.colors.white;
}, function (props) {
    return props.size === 'small' ? '0.33rem 0.66rem' : '0.66rem:';
}, function (props) {
    return props.optionTextMaxLength ? 'nowrap' : '';
}, function (props) { return props.isInline && '95%'; }, function (props) {
    return props.isInline && '.6rem';
}, function (props) {
    return props.optionTextMaxLength ? 'nowrap' : '';
}, function (props) {
    return props.isInline
        ? '1.1667rem'
        : props.bold
            ? '1.1667rem'
            : props.size === 'small'
                ? '1rem'
                : '1.33rem';
}, function (props) {
    return props.optionTextMaxLength ? 'nowrap' : '';
}, function (props) {
    return props.optionTextMaxLength ? 'inherit' : '';
}, function (props) {
    return props.optionTextMaxLength ? 'hidden' : '';
}, function (props) {
    return props.optionTextMaxLength ? 'ellipsis' : '';
}, function (props) {
    return props.optionTextMaxLength ? '85%' : '';
}, function (props) {
    return props.isInline || props.bold ? 'bold' : undefined;
}, function (props) { return props.isInline && '85%'; }, function (props) { return getMenuStyles(props); }, function (props) { return (props.autoResizeHeight ? 'auto' : 'initial'); }, function (props) {
    return props.simple ? 'rgba(0, 36, 45, 0.05)' : props.theme.colors.white;
}, function (props) {
    return props.size === 'small' ? '0.33rem 0.66rem' : '0.66rem:';
}, function (props) { return props.isInline && '95%'; }, function (props) { return props.isInline && '.6rem'; }, function (props) { return getMenuStyles(props); }, function (props) {
    return props.isInline
        ? '1.1667rem'
        : props.bold
            ? '1.1667rem'
            : props.size === 'small'
                ? '1rem'
                : '1.33rem';
}, function (props) {
    return props.isInline || props.bold ? 'bold' : undefined;
}, function (props) { return props.isInline && '85%'; });
exports.Dropdown = styled_1.default(BaseDropdown)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map